// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getWishListState } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import useQueryString from "@store/Framework/Common/Hooks/useQueryString";
import { useSelector } from "react-redux";

const useWishList = (options?: Toolkit.GoogleAnalytics.Options) => {
    const { id } = useQueryString();

    return useSelector((state: ApplicationState) => {
        if (options?.wishList) {
            return options.wishList;
        }

        if (id) {
            return getWishListState(state, id).value;
        }
    });
};

export default useWishList;
